var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#151e2d","fillRule":"evenodd"},[React.createElement("path",{"d":"m0 0h21l-1.9931106 2h-19.0068894z","key":0}),React.createElement("path",{"d":"m0 8h25l-2 2h-23z","key":1}),React.createElement("path",{"d":"m0 16h21l-2.0097508 2h-18.9902492z","key":2})]));
}

IconHamburger.defaultProps = {"height":"18","viewBox":"0 0 25 18","width":"25"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
